import React, { useState, useEffect, useCallback } from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const IdleTimeoutHandler = ({ 
  timeout = 30000, // 30 seconds
  warningTime = 10000, // 10 seconds before timeout
  onTimeout,
  onReset,
  isActive = true,
  children
}) => {
  const [timeLeft, setTimeLeft] = useState(timeout);
  const [showWarning, setShowWarning] = useState(false);
  const [lastActivity, setLastActivity] = useState(Date.now());

  const resetTimer = useCallback(() => {
    setTimeLeft(timeout);
    setShowWarning(false);
    setLastActivity(Date.now());
  }, [timeout]);

  const handleActivity = useCallback(() => {
    if (isActive) {
      resetTimer();
    }
  }, [isActive, resetTimer]);

  const handleTimeout = useCallback(() => {
    setShowWarning(false);
    if (onTimeout) {
      onTimeout();
    }
    if (onReset) {
      onReset();
    }
    resetTimer();
  }, [onTimeout, onReset, resetTimer]);

  const extendSession = () => {
    resetTimer();
    setShowWarning(false);
  };

  // Set up activity listeners
  useEffect(() => {
    if (!isActive) return;

    const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];
    
    events?.forEach(event => {
      document.addEventListener(event, handleActivity, true);
    });

    return () => {
      events?.forEach(event => {
        document.removeEventListener(event, handleActivity, true);
      });
    };
  }, [handleActivity, isActive]);

  // Countdown timer
  useEffect(() => {
    if (!isActive) return;

    const interval = setInterval(() => {
      setTimeLeft(prev => {
        const newTime = prev - 1000;
        
        if (newTime <= warningTime && !showWarning) {
          setShowWarning(true);
        }
        
        if (newTime <= 0) {
          handleTimeout();
          return timeout;
        }
        
        return newTime;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [isActive, warningTime, showWarning, handleTimeout, timeout]);

  const formatTime = (ms) => {
    const seconds = Math.ceil(ms / 1000);
    return seconds;
  };

  return (
    <>
      {children}
      
      {/* Warning Modal - DISABLED */}
      {/* Session timeout popup has been removed as requested */}
    </>
  );
};

export default IdleTimeoutHandler;